<script>
  import Image, { asSrc, asSrcset } from '$lib/Image.svelte'
  import { autoplay } from '$lib/autoplay.js'

  /** @type {import('@prismicio/types').ImageField<'mobile', 'filled'>} */
  export let image

  /** @type {string?} */
  export let video = null

  /** @type {'lazy'|'eager'} */
  export let loading = 'lazy'

  export let fill = false

  $: aspect = image
    ? `${((image.dimensions?.height / image.dimensions?.width) * 100).toFixed(
        2
      )}%`
    : null

  $: aspectMobile = image.mobile
    ? `${(
        (image.mobile.dimensions?.height / image.mobile.dimensions?.width) *
        100
      ).toFixed(2)}%;`
    : null
</script>

<div
  class="figure"
  style:--aspect={aspect}
  style:--aspect-mobile={aspectMobile}
  class:video
  class:fill>
  <div class="container">
    {#if video}
      <div class="poster">
        <video
          use:autoplay
          class="video"
          playsInline
          autoPlay
          muted
          loop
          disablePictureInPicture
          width="960"
          height="540"
          preload="auto"
          poster={image.url}>
          <source src={video} type="video/mp4" />
        </video>
      </div>
    {:else if image.mobile}
      <picture>
        <source
          srcset={asSrcset(image.url, [
            600,
            700,
            [900, 'q_70'],
            [1200, 'q_60'],
            [1600, 'q_50'],
            [2400, 'q_40']
          ])}
          media="(min-width: 500px)"
          sizes="90vw" />
        <source
          srcset={asSrcset(image.mobile.url, [350, 500, 600, 700, 900, 1200])}
          sizes="90vw" />
        <img
          class="image"
          alt={image.alt || ''}
          {...image.dimensions}
          src={asSrc(image.url, 900)}
          {loading} />
      </picture>
    {:else if image.url}
      <Image
        src={image.url}
        alt={image.alt || ''}
        class="image asdfasdf"
        {loading}
        sizes="90vw"
        {...image.dimensions}
        variants={[700, 900, 1200, [1600, 'q_70'], [2400, 'q_70']]} />
    {/if}

    <div class="children"><slot /></div>
  </div>
</div>

<style>
  .figure {
    --aspect: 56.25%;

    display: block;
    width: 100%;
    padding: 0;
    margin: 0;
    text-decoration: none;
    color: currentcolor;
    background: transparent;
  }

  .container {
    padding-bottom: var(--aspect-mobile, var(--aspect));
    position: relative;
    background: rgb(var(--rgb-image-background));
    border-radius: var(--current-border-radius, var(--border-radius-xl));
    overflow: hidden;
  }

  @media (min-width: 700px) {
    .container {
      padding-bottom: var(--aspect);
    }
  }

  .image,
  .container :global(.image),
  .video {
    display: block;
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    object-fit: cover;
    object-position: center;
    pointer-events: none;
  }

  .poster {
    background-color: rgb(var(--rgb-gray));
    user-select: none;
  }

  .fill {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .fill .container {
    padding: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: var(--current-border-radius, 0);
  }

  .children:empty {
    display: none;
  }
</style>
